import { RuleProperties } from '@react-awesome-query-builder/mui';

import { CONTACT_STATUS_CODE_MAPPINGS, isTemplatePlaceholder } from '@/types';
import { isSupporterStatus } from '@/types/filterEnumTypes';
import { SupporterStatusesFilter } from '@/types/searchFilterTypes';
import { FilterMapper } from './filterMapperTypes';
import { AutocompleteGenericEntity } from '@australiangreens/ag-internal-components';

export const SupporterStatusesMapper: FilterMapper = {
  checkIsIncomplete({ value }) {
    const isNoStatusSelected = value[0].value.length === 0;
    return isNoStatusSelected;
  },
  toFilter({ value }: RuleProperties): SupporterStatusesFilter {
    if (!value) throw new Error('Missing value');

    if (value.length !== 1) throw new Error('Invalid value. Expected array of length 1');

    const nestedValue = value[0].value;
    let mappedValue;
    if (isTemplatePlaceholder(nestedValue)) {
      mappedValue = nestedValue;
    } else {
      const entities = value[0] as { value: AutocompleteGenericEntity[] };

      mappedValue = entities.value.map(({ id }) => {
        if (typeof id === 'string' && isSupporterStatus(id)) {
          return id;
        } else {
          throw new Error('Invalid value. Expect array of SupporterStatuses');
        }
      });
    }

    return { name: 'supporterStatuses', value: mappedValue } as SupporterStatusesFilter;
  },

  async fromFilter(filter: SupporterStatusesFilter) {
    if (isTemplatePlaceholder(filter.value)) {
      return {
        field: filter.name,
        operator: 'any in',
        value: [
          {
            value: filter.value,
            errors: [],
          },
        ],
      };
    }
    const supporterStatuses = filter.value.map((status) => ({
      id: status,
      label: CONTACT_STATUS_CODE_MAPPINGS[status],
    }));

    return {
      field: filter.name,
      operator: 'any in',
      value: [{ value: supporterStatuses, errors: [] }],
    };
  },
};
